export default {
  name: 'BaseInput',
  inheritAttrs: false,
  props: {
    modelValue: String,
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)'
    },
    group: {
      type: Boolean,
      description: 'Whether input is an input group (manual override in special cases)'
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: true
    },
    alternative: {
      type: Boolean,
      description: 'Whether input is of alternative layout'
    },
    label: {
      type: String,
      description: 'Input label (text before input)'
    },
    inValidMessage: {
      type: String,
      description: 'Input error (below input)',
      default: '필수항목입니다.'
    },
    successMessage: {
      type: String,
      description: 'Input success message',
      default: ''
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes',
      default: 'form-control-label'
    },
    inputClasses: {
      type: String,
      description: 'Input css classes'
    },
    inputGroupClasses: {
      type: String,
      description: 'Input group css classes'
    },
    value: {
      type: [String, Number],
      description: 'Input value'
    },
    type: {
      type: String,
      description: 'Input type',
      default: 'text'
    },
    appendIcon: {
      type: String,
      description: 'Append icon (right)'
    },
    prependIcon: {
      type: String,
      description: 'Prepend icon (left)'
    },
    maxLength: {
      type: [String, Number],
      description: 'Limited Max Length',
      default: ''
    },
    isFormGroup: {
      type: Boolean,
      description: 'Whether is form-group className',
      default: true
    },
    isFormInline: {
      type: Boolean,
      description: 'form-inline className'
    },
    inlineHeadText: {
      type: String,
      description: 'inline head text'
    },
    inlineTailText: {
      type: String,
      description: 'inline tail text'
    },
    isInlineBlock: {
      type: Boolean,
      description: 'display inline-block'
    },
    span: {
      type: String,
      description: 'small text',
      default: ''
    }
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  data() {
    return {
      focused: false
    };
  },
  computed: {
    listeners() {
      return {
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      };
    },
    slotData() {
      return {
        focused: this.focused,
        inValidMessage: this.inValidMessage,
        ...this.listeners
      };
    },
    hasIcon() {
      const {
        append,
        prepend
      } = this.$slots;
      return append !== undefined || prepend !== undefined || this.appendIcon !== undefined || this.prependIcon !== undefined || this.group;
    }
  },
  methods: {
    updateValue(evt) {
      const value = evt.target.value;
      this.$emit('update:modelValue', value);
    },
    onFocus(evt) {
      this.focused = true;
      this.$emit('focus', evt);
    },
    onBlur(evt) {
      this.focused = false;
      this.$emit('blur', evt);
    }
  }
};